import { render, staticRenderFns } from "./OtaApp.vue?vue&type=template&id=90733ae2&scoped=true&"
import script from "./OtaApp.vue?vue&type=script&lang=js&"
export * from "./OtaApp.vue?vue&type=script&lang=js&"
import style0 from "./OtaApp.vue?vue&type=style&index=0&id=90733ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90733ae2",
  null
  
)

export default component.exports